export function isValidShopName(test: unknown): test is string {
  return typeof test === 'string' && test !== '';
}

export default isValidShopName;
